module.exports = __webpack_public_path__ + "static/img/index2(1)_12.7e40419.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index2(1)_12.png
// module id = 3123
// module chunks = 1